import { useState } from "react";
import { api } from "@/api";
import { ArrowUpRight } from "lucide-react";

export default function NewsletterForm({
  source,
  heading,
  subtext,
  buttonLabel = "Join the Clearing",
  compact = false,
  microcopy = "A short weekly reflection · No spam · Unsubscribe anytime",
}) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await api.post("/subscribe", { email, source });
      setStatus("success");
      setMessage("Welcome to the Clearing — you're on the list.");
      setEmail("");
    } catch (err) {
      setStatus("error");
      const d = err.response?.data?.detail;
      setMessage(typeof d === "string" ? d : "Something went wrong — please try again.");
    }
  };

  return (
    <div className={compact ? "" : "max-w-xl"}>
      {heading && (
        <h3 className="font-playfair text-2xl tracking-tight text-cream sm:text-3xl">
          {heading}
        </h3>
      )}
      {subtext && (
        <p className="mt-3 text-sm leading-relaxed text-cream/70">{subtext}</p>
      )}
      {status === "success" ? (
        <p
          data-testid={`newsletter-success-${source}`}
          className="mt-6 font-playfair text-lg italic text-amber"
        >
          {message}
        </p>
      ) : (
        <form
          onSubmit={submit}
          className={`mt-${compact ? "4" : "6"} flex flex-col gap-3 sm:flex-row`}
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email address"
            data-testid={`newsletter-email-${source}`}
            className="w-full flex-1 rounded-full border border-cream/25 bg-navy-deep/40 px-5 py-3 text-sm text-cream placeholder:text-cream/40 focus:border-amber focus:outline-none transition-colors duration-300"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            data-testid={`newsletter-submit-${source}`}
            className="group inline-flex items-center justify-center gap-2 rounded-full bg-amber px-6 py-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-navy-deep transition-[background-color,transform] duration-300 hover:bg-cream hover:-translate-y-0.5 disabled:opacity-60"
          >
            {status === "loading" ? "Joining…" : buttonLabel}
            <ArrowUpRight size={14} />
          </button>
        </form>
      )}
      {status === "error" && (
        <p data-testid={`newsletter-error-${source}`} className="mt-3 text-sm text-amber">
          {message}
        </p>
      )}
      {!compact && status !== "success" && (
        <p className="mt-3 text-[11px] uppercase tracking-[0.2em] text-cream/40">
          {microcopy}
        </p>
      )}
    </div>
  );
}
